var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12",
    "data-name": "Group 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 569.392,
    height: 765,
    viewBox: "0 0 569.392 765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.987,
    x2: 0.611,
    y2: 0.711,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(239,186,34)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(239,186,34)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M141.031,147.022V659.509a86.554,86.554,0,0,0,32.452,67.76l212.2,170.749a64.271,64.271,0,0,0,80.1,0l212.2-170.749a86.579,86.579,0,0,0,32.446-67.76V147.022Zm556.528,12.867v499.62a73.749,73.749,0,0,1-27.646,57.734L457.718,888a51.345,51.345,0,0,1-63.975,0l-212.2-170.752A73.749,73.749,0,0,1,153.9,659.509V159.889Z",
    transform: "translate(-141.031 -147.022)",
    fill: "rgb(239,186,34)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M187.38,635.95l155.71,125.3a48.877,48.877,0,0,0,60.924,0l155.7-125.294a65.228,65.228,0,0,0,24.449-51.057V168.826H162.931V584.893A65.227,65.227,0,0,0,187.38,635.95Zm192.661-257.38V329.028h86.374a342.245,342.245,0,0,0,73.405,49.541Zm0-124.814v-41.6a341.522,341.522,0,0,0,22.308,41.6ZM454.174,181.7h58.667A212.188,212.188,0,0,0,571.3,244.119v60.6A262.569,262.569,0,0,1,454.174,181.7Zm-72.445,0h58.322A274.616,274.616,0,0,0,571.3,319.117v59.354A330.712,330.712,0,0,1,381.729,181.7Zm-1.688,134.464V266.623h30.707a346.206,346.206,0,0,0,41.839,49.538Zm0,124.82V391.44H569.117c.382.145.754.3,1.13.446.349.142.7.284,1.055.419v48.675ZM528.049,181.7H571.3v46.49A198.041,198.041,0,0,1,528.049,181.7ZM467.877,578.666H571.3v6.227a52.407,52.407,0,0,1-19.653,41.031l-13.818,11.122,1.021-1.272Zm-76.246-44.84L528.868,644.257l-44.454,35.771L331.61,557.842a52.431,52.431,0,0,1-19.646-41.031V181.7h55.214V482.77A65.21,65.21,0,0,0,391.63,533.826Zm.44-17.572H571.3V565.8H451.881L399.694,523.8v0A53.211,53.211,0,0,1,392.07,516.254Zm-68.514,51.625L474.141,688.295l-45.4,36.528L263.532,591.881a52.4,52.4,0,0,1-19.653-41.03V181.7h55.214V516.812A65.24,65.24,0,0,0,323.556,567.879Zm-68.091,34.032L418.481,733.084l-22.535,18.138a35.934,35.934,0,0,1-44.792,0l-155.707-125.3A52.421,52.421,0,0,1,175.8,584.893V181.7h55.214V550.851A65.229,65.229,0,0,0,255.465,601.911ZM380.042,482.77V453.849H571.3v49.538H384.3A52.321,52.321,0,0,1,380.042,482.77Z",
    transform: "translate(-88.853 -95.072)",
    fill: "rgb(239,186,34)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.29a2a4cc6f8604467c05f5fef6140d6f.svg";
export { ForwardRef as ReactComponent };